import React from 'react';
import PropTypes from 'prop-types';

export default class DelayRender extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        delay: PropTypes.number,
    };

    static defaultProps = {
        delay: 250,
    };

    state = {
        visible: false,
    };

    componentDidMount() {
        const {delay} = this.props;

        this.timer = setTimeout(() => {
            this.setState({visible: true});
        }, delay);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        const {children} = this.props;
        const {visible} = this.state;

        if (!visible) {
            return null;
        }

        return children();
    }
}
